import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { MachineCalendar } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class MachineCalendarService extends TmsWebBaseEditCreateService<MachineCalendar, MachineCalendar> {
  constructor() {
    super('MachineCalendar', $localize`Machine Calendar`);
  }

  getForMachine(machineId: string): Observable<MachineCalendar[]> {
    return this.httpService.get<MachineCalendar[]>(`${this.apiUrl}/Machine/${machineId}`);
  }
}
